import React, { useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './Compherensive.css';
import Modal from '../../../Pages/ModalForm';


const Compherensive = () => {
    const [showModal, setShowModal] = useState(false);

    const handleShow = () => {
        setShowModal(true);
    }
    const handleClose = () => setShowModal(false);
    return (
        <>
            <div className="Compherensive">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className='headings text-center'><span>Effortless</span> Travel Management for All Stakeholders</h1>
                            <p className='mt-4 comp-p grotesk-headings'>Ready to transform your corporate travel experience? Often complicated and time-consuming, your corporate trip can be made more effective and memorable with Blueberry Travel. We’re responsible for making complex travel management effortless by offering personalized solutions for business travelers, travel managers, and planners alike. From every flight booking to further steps, we ensure efficiency, cost savings, and exceptional support every step of the way.</p>


                            <div className='row px-lg-5 mlTab'>
                                <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3 d-flex justify-content-center">
                                    <div className="comp-box shadow">
                                        <div className="row">
                                            <div className="col-md-12 radius-image">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/comp1.png" alt="" className="w-100 h-100 img-fluid" loading="lazy"  />
                                            </div>
                                            <div className="col-md-12 p-4 mb-2">
                                                <h5 className="headings text-dark">For Business Travelers
                                                </h5>
                                                <p className="mt-3 ">Make your corporate journey smoother and more efficient with tools and expert support, from start to finish.
                                                </p>
                                                <div className="carouselCaption text-black comp-btn">
                                                    <button className="btn text-black fw-bold"  type="submit" onClick={handleShow}>FIND OUT MORE
                                                    </button>                                                  
                                                </div>
                                                <Modal show={showModal} handleClose={handleClose} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
                                    <div className="comp-box shadow">
                                        <div className="row">
                                            <div className="col-md-12 radius-image">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/comp2.png" alt="" className="w-100 h-100 img-fluid" loading="lazy"  />
                                            </div>
                                            <div className="col-md-12 p-4">
                                                <h5 className="headings  text-dark">For Travel Managers</h5>
                                                <p className="mt-3 ">Optimize the travel program for compliance, duty of care, cost control, consistency, and efficiency across the board.</p>
                                                <div className="carouselCaption text-black comp-btn">
                                                    <button className="btn text-black fw-bold  "  type="submit" onClick={handleShow}>FIND OUT MORE
                                                    
                                                    </button>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
                                    <div className="comp-box shadow">
                                        <div className="row">
                                            <div className="col-md-12 radius-image">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/comp3.png" alt="" className="w-100 h-100 img-fluid" loading="lazy" />
                                            </div>
                                            <div className="col-md-12 p-4">
                                                <h5 className="headings  text-dark">For Travel Planners</h5>
                                                <p className="mt-3 ">Simplify your corporate bookings today with the best tools and support to make travel planning fast, reliable, and stress-free.
                                                </p>
                                                <div className="carouselCaption text-black comp-btn">
                                                    <button className="btn text-black fw-bold "  type="submit" onClick={handleShow}>FIND OUT MORE
                                                    {/* <Modal show={showModal} handleClose={handleClose} /> */}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Compherensive